import type { OperationalReport, ReportPort } from '../domain/operational-report'

const getOperationalReport = async (port: ReportPort): Promise<OperationalReport> => port.getOperationalReport()

export { getOperationalReport }
